import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Daybook } from 'models/DaybookModel';


const DaybookList: React.FC = () => {
  const width = { date: 10, location: 10, terminal: 9, cash: 9, check:9, insurance:9, total:10, payout: 9, cashinhand: 10, createdby: 15 }
  const [formId, formName] = [Code.Form.Id.DAYBOOK, Code.Form.Name.DAYBOOK];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [daybookData, setDaybookData] = useState<Daybook[]>([]); 
  const [selectedDaybook, setselectedDaybook] = useState<Daybook | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.Daybook.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Daybook.Id, 
        Name.Daybook.Date, 
        Name.Location.Name, 
        Name.User.FullName, 
        Name.Daybook.TerminalTotal, 
        Name.Daybook.CheckTotal, 
        Name.Daybook.InsuranceTotal, 
        Name.Daybook.CashTotal, 
        Name.Daybook.GrandTotal, 
        Name.Daybook.PayoutTotal, 
        Name.Daybook.CashInHand, 
      ]),
      location_id: locationId,
    });
     
    await API.Data.List<Daybook>(url, setDaybookData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Role} options={userOptions} onChange={(value) => { setUserId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, daybookData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Date, width.date],
                [Title.Location, width.location],
                [Title.Terminal, width.terminal, Code.Align.RIGHT], 
                [Title.Cash, width.cash, Code.Align.RIGHT], 
                [Title.Check, width.check, Code.Align.RIGHT], 
                [Title.Insurance, width.insurance, Code.Align.RIGHT], 
                [Title.Total, width.total, Code.Align.RIGHT], 
                [Title.Payout, width.payout, Code.Align.RIGHT], 
                [Title.CashInHand, width.cashinhand, Code.Align.RIGHT], 
                [Title.ReceivedBy, width.createdby], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(daybookData) && (
              <Control.Grid.Row>
                {daybookData.map((daybookData) => { return (
                <Control.Grid.Data<Daybook> key={daybookData.daybook_id} itemKey={daybookData.daybook_key} data={daybookData} setMenuPosition={setMenuPosition} setSelectedData={setselectedDaybook} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={daybookData.daybook_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, daybookData.daybook_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [Utility.Format.DateOnly(daybookData.daybook_date), width.date],
                    [daybookData.location_name, width.location],
                    [Utility.Format.Amount(daybookData.daybook_terminal_total), width.terminal, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_cash_total), width.cash, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_check_total), width.check, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_insurance_total), width.insurance, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_grand_total), width.total, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_payout_total), width.payout, Code.Align.RIGHT],
                    [Utility.Format.Amount(daybookData.daybook_cash_in_hand), width.cashinhand, Code.Align.RIGHT],
                    [daybookData.user_first_name, width.createdby],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={daybookData.daybook_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={daybookData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedDaybook?.daybook_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedDaybook?.daybook_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default DaybookList;